import clsx from 'clsx';
import type { FormLocale } from '@jlg-website/shared';
import { periodLabels } from './constants';
import type { SlotPeriod } from './type';

type PeriodTabItemProps = {
  period: SlotPeriod;
  selected: boolean;
  disabled: boolean;
  locale: FormLocale;
  onSelect: (period: SlotPeriod) => void;
};

export function PeriodTabItem({
  period,
  selected,
  disabled,
  locale,
  onSelect,
}: PeriodTabItemProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      aria-pressed={selected}
      onClick={() => onSelect(period)}
      className={clsx(
        'flex-1 rounded-full border py-2 text-sm font-medium transition-colors duration-200',
        disabled && 'cursor-not-allowed border-brand-muted-light text-gray-light',
        !disabled && 'cursor-pointer',
        !disabled && selected && 'border-brand-primary bg-brand-primary text-white',
        !disabled && !selected && 'border-brand-muted-light bg-white text-brand-text-button'
      )}
    >
      {(periodLabels[locale] ?? periodLabels.en)[period]}
    </button>
  );
}
